export default __webpack_public_path__ + "static/media/ic_spain.2e6a8234.svg";